var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 424.2 412.6",
    style: {
      enableBackground: "new 0 0 424.2 412.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E16A0E;}\n\t\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#0E3480;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "part1",
    className: "st0",
    points: "213.9,47.5 56.8,317.3 86.4,317.3 213.9,92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "part2",
    x: 55.5,
    y: 321.2,
    className: "st0",
    width: 51.2,
    height: 49.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "part3",
    x: 163.3,
    y: 321.2,
    className: "st0",
    width: 51.2,
    height: 49.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "part4",
    x: 270.6,
    y: 321.2,
    className: "st0",
    width: 51.2,
    height: 49.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "part5",
    className: "st0",
    points: "324.5,232.7 272.4,317.5 302.2,317.5 324.3,277.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "part6",
    className: "st0",
    points: "268.8,139.1 268.8,186 194.5,317.6 164.6,317.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "part7",
    className: "st1",
    points: "348.8,273.5 325.5,317.1 325.5,366.6 348.9,323.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "part8",
    className: "st1",
    points: "351.7,278 351.7,323 375.6,365.9 375.6,317.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "part9",
    className: "st1",
    points: "297.3,186.6 297.3,231 309.6,251.6 323.1,230"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "part10",
    className: "st1",
    points: "294.4,182.2 294.4,231.5 217.9,366 217.9,317.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "part11",
    className: "st1",
    points: "243.3,97.2 267.1,136 253.7,159.5 243.1,140.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "part12",
    className: "st1",
    points: "240.9,92.2 240.9,139.8 110.3,366.1 110.3,317.1"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaiLogo);
export default __webpack_public_path__ + "static/media/dai-logo.2d7c8faa6f472408c50e64fc8b59c71f.svg";
export { ForwardRef as ReactComponent };